import React from "react";
import { worldAPI } from "../../../../../../engine/modules/world/worldAPI";
import WorldValueInput from "./WorldValueInput";

function GridSettingsRow(props) {
  return (
    <div className="WorldGroup GridSettingsRow">
      <label className="WorldLabel GridSettingsLabel">{props.label}</label>
      <div className="GridSettingsControl">{props.children}</div>
    </div>
  );
}

function GridSettingsButton(props) {
  return (
    <button
      className={`WorldButton ${props.active ? "active" : ""}`}
      aria-pressed={props.active}
      onClick={props.onClick}
      title={props.title}>
      {props.children}
    </button>
  );
}

function GridSettingsSection(props) {
  const refreshSettings = typeof props.getSettings === "function" ? props.getSettings : () => {};
  const setGridVisible = typeof props.setGridVisible === "function" ? props.setGridVisible : () => {};
  const sectionClassName = ["WorldSection", "GridSettingsSection", props.compact ? "compact" : "", props.className || ""]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={sectionClassName}>
      {props.title !== null ? <h3 className="WorldSectionTitle">{props.title || "Grid Settings"}</h3> : null}

      <GridSettingsRow label="Visibility">
        <div className="WorldButtonGroup GridSettingsButtonGroup">
          <GridSettingsButton
            active={props.gridVisible === true}
            onClick={() => {
              if (props.gridVisible !== true) {
                setGridVisible(true);
              }
            }}
            title="Explicitly show grid in this scene state">
            On
          </GridSettingsButton>
          <GridSettingsButton
            active={props.gridVisible === false}
            onClick={() => {
              if (props.gridVisible !== false) {
                setGridVisible(false);
              }
            }}
            title="Explicitly hide grid in this scene state">
            Off
          </GridSettingsButton>
        </div>
      </GridSettingsRow>

      <div className="WorldGroup GridSettingsNumberField">
        <WorldValueInput
          step={1}
          min={1}
          name="Texture Repeat"
          inputWidth="67.5px"
          marginTop={props.compact ? "0px" : undefined}
          value={props.gridTextureRepeat}
          handleUpdate={(value) => {
            worldAPI.setGridTiling(value);
            refreshSettings();
          }}
        />
      </div>

      <GridSettingsRow label="Color Mode">
        <div className="WorldButtonGroup GridSettingsButtonGroup">
          <GridSettingsButton
            active={props.gridColorMode === "dark"}
            onClick={() => {
              if (props.gridColorMode !== "dark") {
                worldAPI.setGridColorMode("dark");
                refreshSettings();
              }
            }}>
            Dark
          </GridSettingsButton>
          <GridSettingsButton
            active={props.gridColorMode === "light"}
            onClick={() => {
              if (props.gridColorMode !== "light") {
                worldAPI.setGridColorMode("light");
                refreshSettings();
              }
            }}>
            Light
          </GridSettingsButton>
        </div>
      </GridSettingsRow>
    </div>
  );
}

export default GridSettingsSection;
